import React, { Component } from 'react';
import { Button, Col, Form, Row } from 'react-bootstrap';
import { DEFAULT_ANNUAL_RETURN_RATE, DEFAULT_WITHDRAWAL_RATE } from '../../../constants/fireDefaults';

class FireAssumptionsForm extends Component {
  constructor(props) {
    super(props);
    const a = props.assumptions;
    this.state = {
      annualSpending: a.annualSpending !== null ? a.annualSpending : '',
      annualSavings: a.annualSavings !== null ? a.annualSavings : '',
      currentAge: a.currentAge !== null ? a.currentAge : '',
      annualReturnRate: parseFloat((a.annualReturnRate * 100).toFixed(2)),
      withdrawalRate: parseFloat((a.withdrawalRate * 100).toFixed(2)),
    };
    this.handleSubmit = this.handleSubmit.bind(this);
  }

  handleSubmit() {
    const { annualSpending, annualSavings, currentAge, annualReturnRate, withdrawalRate } = this.state;
    this.props.onSave({
      annualSpending: parseFloat(annualSpending),
      annualSavings: parseFloat(annualSavings),
      currentAge: parseInt(currentAge, 10),
      annualReturnRate: parseFloat(annualReturnRate) / 100,
      withdrawalRate: parseFloat(withdrawalRate) / 100,
    });
  }

  handleChange(field, value) {
    this.setState({ [field]: value });
  }

  render() {
    const { annualSpending, annualSavings, currentAge, annualReturnRate, withdrawalRate } = this.state;
    return (
      <Form onSubmit={e => e.preventDefault()}>
        <Row className="mb-3">
          <Form.Group as={Col} md={4}>
            <Form.Label>Annual Spending Target</Form.Label>
            <Form.Control
              type="number"
              min="0"
              placeholder={`e.g. 60000`}
              value={annualSpending}
              onChange={e => this.handleChange('annualSpending', e.target.value)}
              required
            />
            <Form.Text className="text-muted">How much you plan to spend per year in retirement</Form.Text>
          </Form.Group>
          <Form.Group as={Col} md={4}>
            <Form.Label>Annual Savings</Form.Label>
            <Form.Control
              type="number"
              min="0"
              placeholder="e.g. 24000"
              value={annualSavings}
              onChange={e => this.handleChange('annualSavings', e.target.value)}
              required
            />
            <Form.Text className="text-muted">How much you save per year</Form.Text>
          </Form.Group>
          <Form.Group as={Col} md={4}>
            <Form.Label>Current Age</Form.Label>
            <Form.Control
              type="number"
              min="1"
              max="100"
              placeholder="e.g. 30"
              value={currentAge}
              onChange={e => this.handleChange('currentAge', e.target.value)}
              required
            />
          </Form.Group>
        </Row>
        <Row className="mb-3">
          <Form.Group as={Col} md={4}>
            <Form.Label>Expected Annual Return (%)</Form.Label>
            <Form.Control
              type="number"
              min="0"
              max="30"
              step="0.01"
              placeholder={`${DEFAULT_ANNUAL_RETURN_RATE * 100}`}
              value={annualReturnRate}
              onChange={e => this.handleChange('annualReturnRate', e.target.value)}
              required
            />
            <Form.Text className="text-muted">Real (inflation-adjusted) return rate</Form.Text>
          </Form.Group>
          <Form.Group as={Col} md={4}>
            <Form.Label>Safe Withdrawal Rate (%)</Form.Label>
            <Form.Control
              type="number"
              min="0"
              max="20"
              step="0.01"
              placeholder={`${DEFAULT_WITHDRAWAL_RATE * 100}`}
              value={withdrawalRate}
              onChange={e => this.handleChange('withdrawalRate', e.target.value)}
              required
            />
            <Form.Text className="text-muted">Typically 4% (the 4% rule)</Form.Text>
          </Form.Group>
        </Row>
        <Button variant="primary" type="button" onClick={this.handleSubmit}>Calculate</Button>
      </Form>
    );
  }
}

export default FireAssumptionsForm;
